import { render, staticRenderFns } from "./page-summary-section-group-layout.vue?vue&type=template&id=437a2b4a&scoped=true"
import script from "./page-summary-section-group-layout.vue?vue&type=script&lang=ts"
export * from "./page-summary-section-group-layout.vue?vue&type=script&lang=ts"
import style0 from "./page-summary-section-group-layout.vue?vue&type=style&index=0&id=437a2b4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437a2b4a",
  null
  
)

export default component.exports